<template>
  <div>
    <a-modal :title="title" :bodyStyle="{ 'min-height': '500px' }" :width="800" :visible="visible" @ok="handleOk" @cancel="handleCancel">
      <a-spin :spinning="loading">
        <div class="page">
          <!-- <div style="width: 100%" v-if="flag">
            <a v-for="(item, index) in files" :key="item.index" @click="toSee(item)" style="font-size:16px"
              >附件：{{ item.fileName ? item.fileName : '暂无' }}</a
            >
          </div> -->

          <a-upload
            v-model="fileids"
            :multiple="true"
            :action="fileUpload"
            :fileList="fileList"
            :data="{ code: '#', type: 'asns' }"
            accept=".pdf,.jpg,.png"
            class="upload-list-inline"
            list-type="text"
            @change="handleUpload"
            @preview="handlePreview"
          >
             <a-button> <a-icon type="upload" /> 上传 </a-button>
              <span> （支持.pdf、.png、.jpg格式文件）</span>
            </a-upload>
          </a-upload>
          <a-modal
            width="1200px"
            :bodyStyle="{ 'min-height': '600px' }"
            title="查看图片"
            :visible="previewVisible"
            :footer="null"
            @cancel="handleCancel2"
          >
            <img alt="example" style="width: 100%" :src="url" />
          </a-modal>



          <!-- <div>
            <span style="padding-right:10px">附件:</span>
            <a-upload
              v-model="fileids"
              :multiple="true"
              :action="fileUpload"
              :fileList="fileList"
              :data="{ code: '#', type: 'asns' }"
              accept=".pdf,.jpg,.png"
              class="upload-list-inline"
              list-type="picture-card"
              @change="handleUpload"
              @preview="handlePreview"
            >
  
              <a-button> <a-icon type="upload" /> 上传 </a-button>
              <span> （支持.pdf、.png、.jpg格式文件）</span>
            </a-upload>
          </div> -->

        </div>
        <pdf-module ref="pdf"></pdf-module>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
import moment from 'moment'
import { api, fileUpload, fileDelete } from '@/api/public'
import { getStore, SPF } from '@/utils/storage'
import pdf from '@/components/pdf/pdf.vue'
import PdfModule from './PdfModule.vue'
export default {
  name: 'ASNUpload',
  components: {
    'v-pdf': pdf,
    PdfModule,
  },
  data() {
    return {
      title: '附件',
      visible: false,
      dataSource: [],
      footer: undefined,
      fileName: null,
      fileids: '',
      fileList: [],
      fileUpload: '',
      flag: false,
      pdfUrl:'',
      id: '',
      previewVisible: false,
      url: '',
      downloadUrl: '',
      isimg: false,
      ispdf: false,
      isadd: false,
      loading: false,
      baseInfo: null,
      index: '',
      files: []
    }
  },
  created() {
    const res = getStore(SPF.API)
    this.fileUpload = (res ? '/' + res.substring(res.indexOf('@') + 1) : '') + api.fileUpload2
  },
  methods: {
    toSee(item) {
      const ispdf = item.filename.includes('.pdf')
      if (ispdf) {
        const res = getStore(SPF.API)
        let downloadUrl = (res ? '/' + res.substring(res.indexOf('@') + 1) : '') + api.fileDownload + '?id=' + item.id
        window.open(downloadUrl)
        //pdf
      } else {
        this.previewVisible = true
        const res = getStore(SPF.API)
        this.url = (res ? '/' + res.substring(res.indexOf('@') + 1) : '') + api.fileDownload + '?id=' + item.id
      }
    },
    handlePreview(file) {
      console.log('file',file);
      
      if(file.filetype=='.pdf'||file.type=='application/pdf'){
        this.$refs.pdf.OpenEmPdf(file)
        //  const res = getStore(SPF.API)
        // let downloadUrl = (res ? '/' + res.substring(res.indexOf('@') + 1) : '') + api.fileDownload + '?id=' + file.id
        // window.open(downloadUrl)
      }else{
      this.previewVisible = true
      this.url = file.url
      }
    },

    handleUpload(e) {
      const that = this
      const fileList = [...e.fileList]
      fileList.forEach(item=>{
        // 这么做是为了回显
        if(item.response){
          item.id=item.response.data[0].id
          item.filename=item.response.data[0].filename
        }
      })
      this.fileList=fileList
      if (e.file.status == 'removed') {
        fileDelete({ id: e.file.id }).then(res => {
          if (res.code == 0) {
            that.$message.success('删除成功！')
          } else {
            that.$message.error(res.msg ? res.msg : '删除失败')
          }
        })
      }
      console.log('this.fileList', this.fileList)
      this.fileids =
        this.fileList &&
        this.fileList
          .map(item => {
            if (item.response) {
              return item.response ? item.response.data[0].id : ''
            } else {
              return item.id
            }
          })
          .join()
    },
    date2string(df) {
      if (df) {
        return moment(df).format('YYYY-MM-DD')
      } else {
        return undefined
      }
    },
    handleCancel2() {
      this.previewVisible = false
    },
    toUpload(record, index) {
      this.visible = true
      this.loading = false
      this.index = index
      this.baseInfo = record
      this.isadd = true
      this.flag = false
      this.footer = undefined
      this.fileList = []
    },

    toPreview(record, index) {
      console.log('record',record);
      debugger
      this.visible = true
      this.footer = null
      this.isadd = true
      this.flag = true
      this.baseInfo = record
      this.index = index
      if (record.files && record.files.length > 0) {
        const res = getStore(SPF.API)
        record.files.forEach(item => {
          item.uid = item.id
          item.status = 'done'
          item.url = (res ? '/' + res.substring(res.indexOf('@') + 1) : '') + api.fileDownload + '?id=' + item.id
          item.name = item.filename
        })
      }
      this.fileList = record.files
      console.log('this.fileList', this.fileList)
    },
    handleOk() {
      this.$emit('success', this.fileids, this.index,this.fileList)
      this.visible = false
    },
    handleCancel() {
      this.visible = false
    }
  }
}
</script>
<style lang="scss" scoped>
.page {
  display: flex;
  justify-content: center;
  align-items: center;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
